/**
 * CSS for document previews. It lives in TypeScript rather than SCSS because the Live Lease preview renders
 * into a pop-out window, which has none of the app's stylesheets, so the styles are injected into whichever
 * document the preview mounts in.
 */
export const PREVIEW_PANE_CSS = `
.lh-preview-scroll { position: relative; overflow: auto; background: #d9dde3; }
.lh-preview-staging { position: absolute; left: 0; top: 0; width: 100%; height: 0; overflow: hidden; visibility: hidden; pointer-events: none; }
.lh-preview-scroll .lh-docx-wrapper { background: transparent; padding: 24px 16px 8px; }
.lh-preview-scroll .lh-docx-wrapper > section.lh-docx { box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25); margin-bottom: 24px; }

.lh-token { border-radius: 2px; transition: background-color 0.4s; }
.lh-token--value { background: rgba(255, 213, 0, 0.32); box-shadow: inset 0 -1px 0 rgba(176, 132, 0, 0.7); }
.lh-token--empty { background: rgba(229, 72, 77, 0.12); color: #b42318; font-style: italic; }
.lh-token--unfilled, .lh-token--unknown { background: rgba(229, 72, 77, 0.28); box-shadow: inset 0 0 0 1px rgba(180, 35, 24, 0.75); }
.lh-token--known { background: rgba(18, 150, 90, 0.2); box-shadow: inset 0 -1px 0 rgba(18, 120, 72, 0.75); }
p.lh-token--block { background: rgba(59, 130, 246, 0.06); box-shadow: inset 3px 0 0 rgba(59, 130, 246, 0.7); }

.lh-preview--clickable .lh-token { cursor: pointer; }
.lh-preview--clickable .lh-token:hover { outline: 2px solid rgba(37, 99, 235, 0.85); outline-offset: 1px; }

.lh-preview--plain .lh-token { background: transparent; box-shadow: none; color: inherit; font-style: inherit; }
.lh-preview--plain p.lh-token--block { background: transparent; box-shadow: none; }

@keyframes lh-token-changed {
    0%, 35% { box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.8); }
    100% { box-shadow: 0 0 0 3px rgba(37, 99, 235, 0); }
}
.lh-token--changed { animation: lh-token-changed 1.8s ease-out; }
`;

/** Pulse on the form field a preview click jumped to. Lives in the main app window. */
export const JUMP_TARGET_CSS = `
@keyframes lh-jump-target {
    0%, 60% { box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.75); }
    100% { box-shadow: 0 0 0 3px rgba(37, 99, 235, 0); }
}
.lh-jump-target { animation: lh-jump-target 1.8s ease-out; border-radius: 3px; }
`;

/** Adds a stylesheet to a document once; safe to call on every mount. */
export function ensureStyles(doc: Document, id: string, css: string): void {
    if (doc.getElementById(id)) {
        return;
    }

    const style = doc.createElement('style');
    style.id = id;
    style.textContent = css;
    doc.head.appendChild(style);
}



// WEBPACK FOOTER //
// ./src/components/common/docxPreview/docxPreviewStyles.ts